"use client";

import { c as _c } from "react/compiler-runtime";
import React, { useEffect, useRef } from "react";
const SkipToContent = () => {
  const $ = _c(3);
  const linkRef = useRef(null);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      const handleKeyDown = e => {
        if (e.key === "Tab") {
          const active = document.activeElement;
          if (active === document.body || active === null) {
            linkRef.current?.focus();
            e.preventDefault();
          }
        }
      };
      document.addEventListener("keydown", handleKeyDown);
      return () => document.removeEventListener("keydown", handleKeyDown);
    };
    t1 = [];
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  useEffect(t0, t1);
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <a ref={linkRef} className="absolute left-1/2 h-9 py-2 px-8 -translate-y-full motion-safe:transition-all motion-safe:duration-300 border border-blue-trmb border-t-0 text-blue-trmb text-sm z-[6] bg-white font-['Open_Sans',Arial,sans-serif] max-sm:top-0.5 max-sm:left-[36%] focus:translate-y-0 focus:outline focus:outline-2 focus:outline-blue-sky" href="#page-content">Skip to content</a>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
};
export default SkipToContent;